export enum NewViewTypeEnum {
    NewTab = 1,
    NewWindow = 2
}
